import React, { useState, useCallback } from 'react';
import { Image } from '@brandwatch/axiom-components';

const ImageWithFallback = props => {
  const [hasFinished, setHasFinished] = useState(false);

  const memoizedOnEvent = useCallback(() => setHasFinished(true));

  return (
    <div
      style={{ visibility: hasFinished ? 'visible' : 'hidden' }}
      className="ImageWithFallback"
    >
      <Image {...props} onLoad={memoizedOnEvent} onError={memoizedOnEvent} />
    </div>
  );
};

export default React.memo(ImageWithFallback);
